import { ButtonProps, createPolymorphicComponent } from '@mantine/core'
import { IconKey } from '@tabler/icons-react'
import React from 'react'
import TableActionButton from './TableActionButton'
interface MyComponentProps
    extends ButtonProps,
        React.RefAttributes<HTMLButtonElement> {}
const _TableKeyEditButton = ({
    classNames,
    styles,
    unstyled,
    className,
    ...others
}: MyComponentProps) => {
    return (
        <TableActionButton
            Icon={IconKey}
            label={'แก้ไข'}
            classNames={classNames}
            styles={styles}
            unstyled={unstyled}
            className={className}
            {...others}
        />
    )
}

const TableKeyEditButton = createPolymorphicComponent<
    'button',
    MyComponentProps
>(_TableKeyEditButton)
export default TableKeyEditButton
